var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('customer-form',{attrs:{"customer":_vm.customer,"type":"create","titlePrefix":_vm.$t('customer.create.texts.title-prefix')},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }